module.exports = __webpack_public_path__ + "static/img/二维码.8262d8c8.png@3x.457d4db5.png";